module.exports = __webpack_public_path__ + "static/media/9.3c3670a4.jpg";